export const aboutTranslations = {
  es: {
    about: {
      tag: "Nuestra Identidad",
      title: "IA para apoyar decisiones diagnósticas en la práctica clínica real",
      description: "Integramos herramientas de IA al flujo de trabajo de especialistas para ayudar a detectar hallazgos, priorizar casos y ganar confianza diagnóstica, sin reemplazar el criterio médico.",
      features: {
        neutrality: {
          title: "Libertad de Elección (Vendor Neutrality):",
          text: "Los ecosistemas cerrados comprometen la excelencia clínica por conveniencia comercial. Operamos como asesores estructuralmente agnósticos: filtramos e integramos los mejores algoritmos a nivel global que resuelvan su problema específico, sin sesgos hacia ninguna marca particular."
        },
        independence: {
          title: "Independencia Total (Zero Strings Attached):",
          text: "Construimos infraestructuras interoperables donde la institución de salud retiene el control absoluto y perpetuo de sus flujos. Nuestro modelo garantiza un crecimiento tecnológico sostenible sin apresarlo jamás en silos de datos ni ataduras de proveedores (\"vendor lock-in\")."
        }
      },
      areasTitle: "Áreas en que trabajamos",
      viewPortfolio: "Ver portafolio",
      areas: {
        imagenologia: "Imagenología",
        dermatologia: "Dermatología",
        saludMental: "Salud Mental",
        cardiologia: "Cardiología",
        laboratorios: "Laboratorios Clínicos",
      },
    },
  },
  en: {
    about: {
      tag: "Our Identity",
      title: "AI to support diagnostic decisions in real clinical practice",
      description: "We integrate AI tools into specialists' workflows to help detect findings, prioritize cases, and build diagnostic confidence, without replacing clinical judgment.",
      features: {
        neutrality: {
          title: "Freedom of Choice (Vendor Neutrality):",
          text: "Closed ecosystems compromise clinical excellence for commercial convenience. We operate as structurally agnostic advisors: we filter and integrate the best global algorithms that solve your specific problem, without bias towards any particular brand."
        },
        independence: {
          title: "Total Independence (Zero Strings Attached):",
          text: "We build interoperable infrastructures where the healthcare institution retains absolute and perpetual control of its flows. Our model guarantees sustainable technological growth without ever trapping you in data silos or vendor lock-in."
        }
      },
      areasTitle: "Areas we work in",
      viewPortfolio: "View portfolio",
      areas: {
        imagenologia: "Imaging",
        dermatologia: "Dermatology",
        saludMental: "Mental Health",
        cardiologia: "Cardiology",
        laboratorios: "Clinical Labs",
      },
    },
  },
};
